import { reatomAsync } from "@reatom/async";
import { AccessAwardDto } from "definitions/poizon-sso";
import { API } from "src/api";

export const addAccessRight = reatomAsync(async (ctx, data: AccessAwardDto) => {
  await API.awardApi.awardControllerAddAccessRight(data);
}, "addAccessRight");
